module.exports = __webpack_public_path__ + "static/media/TelecomunicacionesImgEng.ab3cd2c7.png";